import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { noWhitespaceValidator } from '@piqet-angular/data';
import { CustomModalService } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-copy-sub-product',
  templateUrl: './copy-sub-product.component.html',
  styleUrls: ['./copy-sub-product.component.scss'],
})
export class CopySubProductComponent {
  @Output() saveCopyProductEvent = new EventEmitter<{ payload: any }>();
  productData: any;
  copyProductForm!: FormGroup;
  submitted = false;
  isProductConfig: any;
  modalLabel: string = 'Copy product';
  constructor(private formBuilder: FormBuilder, private modal: CustomModalService) {
    this.productData = this.modal?.modalService?.config?.initialState?.['productData'];
    this.isProductConfig = this.modal?.modalService?.config?.initialState?.['isProductConfig'];
  }

  ngOnInit(): void {
    this.copyProductForm = this.formBuilder.group({
      productName: [
        this.productData.productName + ' ' + '_Copy' || '',
        [Validators.required, noWhitespaceValidator, Validators.maxLength(50)],
      ],
    });
  }

  onClose() {
    this.modal.close();
  }

  onSave() {
    this.submitted = true;
    if (this.copyProductForm.invalid) {
      return;
    }
    const payload: any = {
      name: this.copyProductForm.controls['productName'].value,
    };
    if (this.isProductConfig) {
      payload['productConfigId'] = this.productData.productConfigId;
    } else {
      payload['productId'] = this.productData.productId;
    }
    this.saveCopyProductEvent.emit({ payload });
  }
}
